import { type ConfigObject } from './types';

import type { ConfigName } from './names';

export async function mapConfigs(project: ConfigName): Promise<ConfigObject> {
    switch (project) {
        case 'Local Fleet Server':
            return (await import(/* webpackChunkName: "configLocal" */ './kunden/30179_fleet'))?.default;
        case 'BDK BETA':
            return (await import(/* webpackChunkName: "configLocal" */ './kunden/54612_BDKBETA'))?.default;
        case 'ACC':
            return (await import(/* webpackChunkName: "configACC" */ './kunden/30159'))?.default;
        case 'Albertsmeyer':
            return (await import(/* webpackChunkName: "configAlbertsmeyer" */ './kunden/52400'))?.default;
        case 'AMB':
            return (await import(/* webpackChunkName: "configAMB" */ './kunden/12290'))?.default;
        case 'ASS Senftenberg':
            return (await import(/* webpackChunkName: "configASS" */ './kunden/36189'))?.default;
        case 'Auto Diehl':
            return (await import(/* webpackChunkName: "configDiehl" */ './kunden/30165'))?.default;
        case 'Auto Henke':
            return (await import(/* webpackChunkName: "configHenke" */ './kunden/54790'))?.default;
        case 'Autohaus Bauer':
            return (await import(/* webpackChunkName: "configBauer" */ './kunden/30150_Bauer'))?.default;
        case 'Autohaus Cramer-Schmitz':
            return (await import(/* webpackChunkName: "configCramerSchmitz" */ './kunden/54810'))?.default;
        case 'Autohaus-Digital Fleet':
            return (await import(/* webpackChunkName: "configLocal" */ './_local'))?.default;
        case 'Autohaus-Digital S-R':
            return (await import(/* webpackChunkName: "configLocalSr" */ './_localSr'))?.default;
        case 'Autohaus Baumann':
            return (await import(/* webpackChunkName: "configBaumann" */ './kunden/54320'))?.default;
        case 'Autohaus Bäumer':
            return (await import(/* webpackChunkName: "configBaumer" */ './kunden/54806'))?.default;
        case 'Autohaus Baumhoff':
            return (await import(/* webpackChunkName: "configBaumhoff" */ './kunden/53670'))?.default;
        case 'Autocenter Burgenland':
            return (await import(/* webpackChunkName: "configBurgenland" */ './kunden/52960'))?.default;
        case 'Autohaus Dippoldiswalde':
            return (await import(/* webpackChunkName: "configDippoldiswalde" */ './kunden/54130'))?.default;
        case 'Autohaus Eckstein':
            return (await import(/* webpackChunkName: "configEckstein" */ './kunden/54811'))?.default;
        case 'Autohaus Elmshorn':
            return (await import(/* webpackChunkName: "configElmshorn" */ './kunden/30173'))?.default;
        case 'Autohaus Erlenhoff':
            return (await import(/* webpackChunkName: "configErlenhoff" */ './kunden/52590'))?.default;
        case 'Autohaus Feicht':
            return (await import(/* webpackChunkName: "configFeicht" */ './kunden/50860'))?.default;
        case 'Autohaus Franke':
            return (await import(/* webpackChunkName: "configFranke" */ './kunden/49252'))?.default;
        case 'Autohaus G. Neumann':
            return (await import(/* webpackChunkName: "configNeumann" */ './kunden/48801'))?.default;
        case 'Autohaus Häfner':
            return (await import(/* webpackChunkName: "configHafner" */ './kunden/54807'))?.default;
        case 'Autohaus Hannuschka':
            return (await import(/* webpackChunkName: "configHoch" */ './kunden/54794'))?.default;
        case 'Autohaus Hoch':
            return (await import(/* webpackChunkName: "configHoch" */ './kunden/53420'))?.default;
        case 'Autohaus Hoppe':
            return (await import(/* webpackChunkName: "configHoppe" */ './kunden/53910'))?.default;
        case 'Autohaus Hoppe - Test Domain':
            return (await import(/* webpackChunkName: "configHoppeTestDomain" */ './kunden/53910_testDomain'))?.default;
        case 'Autohaus Hoppmann & Schneider':
            return (await import(/* webpackChunkName: "configHoppmannSchneider" */ './kunden/54785'))?.default;
        case 'Autohaus Ihle':
            return (await import(/* webpackChunkName: "configIhle" */ './kunden/51410'))?.default;
        case 'Autohaus Josef Geers':
            return (await import(/* webpackChunkName: "configJosefGeers" */ './kunden/54565'))?.default;
        case 'Autohaus Kießling':
            return (await import(/* webpackChunkName: "configKiessling" */ './kunden/36883'))?.default;
        case 'Autohaus Kießling WEB':
            return (await import(/* webpackChunkName: "configKiessling" */ './kunden/36883_WEB'))?.default;
        case 'Autohaus Koch':
            return (await import(/* webpackChunkName: "configKoch" */ './kunden/53920'))?.default;
        case 'Autohaus Küver':
            return (await import(/* webpackChunkName: "configKuever" */ './kunden/54793'))?.default;
        case 'Autohaus Kuhn+Witte':
            return (await import(/* webpackChunkName: "configKuhnWitte" */ './kunden/30156'))?.default;
        case 'Autohaus Lamminger':
            return (await import(/* webpackChunkName: "configLamminger" */ './kunden/53890'))?.default;
        case 'Autohaus Lich':
            return (await import(/* webpackChunkName: "configLich" */ './kunden/54600'))?.default;
        case 'Autohaus Lucks':
            return (await import(/* webpackChunkName: "configLucks" */ './kunden/51420'))?.default;
        case 'Autohaus an der Lutherkirche':
            return (await import(/* webpackChunkName: "configLutherkirche" */ './kunden/48123'))?.default;
        case 'Autohaus Manz':
            return (await import(/* webpackChunkName: "configManz" */ './kunden/11910'))?.default;
        case 'Autohaus Meinhold':
            return (await import(/* webpackChunkName: "configMeinhold" */ './kunden/11970'))?.default;
        case 'Autohaus Niggemeier':
            return (await import(/* webpackChunkName: "configNiggemeier" */ './kunden/54778'))?.default;
        case 'Autohaus Nord':
            return (await import(/* webpackChunkName: "configNord" */ './kunden/30178'))?.default;
        case 'Autohaus Perski':
            return (await import(/* webpackChunkName: "configPerski" */ './kunden/10190'))?.default;
        case 'Autohaus Pietsch':
            return (await import(/* webpackChunkName: "configPietsch" */ './kunden/54809'))?.default;
        case 'Autohaus Rabus':
            return (await import(/* webpackChunkName: "configRabus" */ './kunden/54789'))?.default;
        case 'Autohaus Range':
            return (await import(/* webpackChunkName: "configRange" */ './kunden/54360'))?.default;
        case 'Autohaus Rudolph':
            return (await import(/* webpackChunkName: "configRudolph" */ './kunden/30150'))?.default;
        case 'Autohaus Schäfer':
            return (await import(/* webpackChunkName: "configSchaefer" */ './kunden/54808'))?.default;
        case 'Autohaus Schäfer Hyundai':
            return (await import(/* webpackChunkName: "configSchaeferHyundai" */ './kunden/54808_Hyundai'))?.default;
        case 'Autohaus Schäfer Mazda':
            return (await import(/* webpackChunkName: "configSchaeferMazda" */ './kunden/54808_Mazda'))?.default;
        case 'Autohaus Schäfer Nissan':
            return (await import(/* webpackChunkName: "configSchaeferNissan" */ './kunden/54808_Nissan'))?.default;
        case 'Autohaus Schenkel':
            return (await import(/* webpackChunkName: "configSchenkel" */ './kunden/54615'))?.default;
        case 'Autohaus Seifert':
            return (await import(/* webpackChunkName: "configSeifert" */ './kunden/30150_Seifert'))?.default;
        case 'Autohaus Schulz & Straube S-R':
            return (await import(/* webpackChunkName: "configSchulzStraubeSR" */ './kunden/48921_SR'))?.default;
        case 'Autohaus Schulz & Straube':
            return (await import(/* webpackChunkName: "configSchulzStraube" */ './kunden/48921'))?.default;
        case 'Autohaus Spranger':
            return (await import(/* webpackChunkName: "configSpranger" */ './kunden/10210'))?.default;
        case 'Autohaus Steinhoff':
            return (await import(/* webpackChunkName: "configSteinhoff" */ './kunden/54782'))?.default;
        case 'Autohaus Vollmer':
            return (await import(/* webpackChunkName: "configVollmer" */ './kunden/11440'))?.default;
        case 'Autohaus Weber':
            return (await import(/* webpackChunkName: "configWeber" */ './kunden/49612'))?.default;
        case 'Autohaus Winter':
            return (await import(/* webpackChunkName: "configWinter" */ './kunden/53810'))?.default;
        case 'Autohaus Wittenberg':
            return (await import(/* webpackChunkName: "configWittenberg" */ './kunden/11980'))?.default;
        case 'Automobile Werner':
            return (await import(/* webpackChunkName: "configWerner" */ './kunden/12040'))?.default;
        case 'autonext':
            return (await import(/* webpackChunkName: "configAutonext" */ './kunden/54805'))?.default;
        case 'Autopark Dippel':
            return (await import(/* webpackChunkName: "configDippel" */ './kunden/53040'))?.default;
        case 'Autowelt Schuler':
            return (await import(/* webpackChunkName: "configSchuler" */ './kunden/30046'))?.default;
        case 'Autozentrale Sturm':
            return (await import(/* webpackChunkName: "configSturm" */ './kunden/54040'))?.default;
        case 'Autozentrum Frankenthal':
            return (await import(/* webpackChunkName: "configFrankenthal" */ './kunden/54599'))?.default;
        case 'Auto Brass':
            return (await import(/* webpackChunkName: "configBrass" */ './kunden/54440'))?.default;
        case 'Auto Hofmann':
            return (await import(/* webpackChunkName: "configHofmann" */ './kunden/30169'))?.default;
        case 'Auto Meyer':
            return (await import(/* webpackChunkName: "configMeyer" */ './kunden/53770'))?.default;
        case 'Auto Müller':
            return (await import(/* webpackChunkName: "configMueller" */ './kunden/54100'))?.default;
        case 'Auto Zeilinger':
            return (await import(/* webpackChunkName: "configZeilinger" */ './kunden/54625'))?.default;
        case 'AV Beier':
            return (await import(/* webpackChunkName: "configAvBeier" */ './kunden/53850'))?.default;
        case 'AVEMO Fleet':
            return (await import(/* webpackChunkName: "configAvemoFleet" */ './kunden/30179_fleet'))?.default;
        case 'AVEMO Gruppe':
            return (await import(/* webpackChunkName: "configAvemo" */ './kunden/30179'))?.default;
        case 'AZF Gruppe':
            return (await import(/* webpackChunkName: "configAZF" */ './kunden/54781'))?.default;
        case 'BaderMainzl':
            return (await import(/* webpackChunkName: "configBadermainzl" */ './kunden/54610'))?.default;
        case 'Best':
            return (await import(/* webpackChunkName: "configBest" */ './kunden/30180'))?.default;
        case 'Best S-R':
            return (await import(/* webpackChunkName: "configBestSR" */ './kunden/30180_SR'))?.default;
        case 'Block am Ring':
            return (await import(/* webpackChunkName: "configBlockAmRing" */ './kunden/30167'))?.default;
        case 'Boxhammer':
            return (await import(/* webpackChunkName: "configBoxhammer" */ './kunden/51460'))?.default;
        case 'Caravan Center Nord':
            return (await import(/* webpackChunkName: "configCaravanCenterNord" */ './kunden/54787'))?.default;
        case 'Clever-Driver-Wetzlar':
            return (await import(/* webpackChunkName: "configMuellerCDW" */ './kunden/54100_CDW'))?.default;
        case 'Dabag':
            return (await import(/* webpackChunkName: "configDabag" */ './kunden/30174'))?.default;
        case 'Dein Autozentrum Woldegk':
            return (await import(/* webpackChunkName: "configWoldegk" */ './kunden/30175'))?.default;
        case 'Die Autohaus Gruppe S-R':
            return (await import(/* webpackChunkName: "configDieAutohausGruppeSR" */ './kunden/30008'))?.default;
        case 'Eichsfelder Autohaus':
            return (await import(/* webpackChunkName: "configEichsfelder" */ './kunden/54170'))?.default;
        case 'Elbtor':
            return (await import(/* webpackChunkName: "configElbtor" */ './kunden/54150'))?.default;
        case 'Feddersen':
            return (await import(/* webpackChunkName: "configFeddersen" */ './kunden/21700'))?.default;
        case 'Fink':
            return (await import(/* webpackChunkName: "configFink" */ './kunden/54623'))?.default;
        case 'FSN Autohaus':
            return (await import(/* webpackChunkName: "configFSN" */ './kunden/30168'))?.default;
        case 'Gebr Conrad':
            return (await import(/* webpackChunkName: "configGebrConrad" */ './kunden/48731'))?.default;
        case 'Glöckner Automobile':
            return (await import(/* webpackChunkName: "configGlockner" */ './kunden/30170'))?.default;
        case 'Grampp':
            return (await import(/* webpackChunkName: "configGrampp" */ './kunden/51530'))?.default;
        case 'Gröditzer Autohaus':
            return (await import(/* webpackChunkName: "configGroeditzer" */ './kunden/13540'))?.default;
        case 'Hager und Penzel':
            return (await import(/* webpackChunkName: "configHagerUndPenzel" */ './kunden/54795'))?.default;
        case 'Henke Automobile - SEAT Wedel':
            return (await import(/* webpackChunkName: "configHenkeSeat" */ './kunden/30156_Henke'))?.default;
        case 'Hoppmann':
            return (await import(/* webpackChunkName: "configHoppmann" */ './kunden/54612'))?.default;
        case 'Kaesmann':
            return (await import(/* webpackChunkName: "configKaesmann" */ './kunden/54622'))?.default;
        case 'KFZ Rothmund':
            return (await import(/* webpackChunkName: "configRothmund" */ './kunden/54804'))?.default;
        case 'Kuenzig Bleuel':
            return (await import(/* webpackChunkName: "configKuenzigBleuel" */ './kunden/54624'))?.default;
        case 'Kuenzig Bleuel Hyundai':
            return (await import(/* webpackChunkName: "configKuenzigBleuelHyundai" */ './kunden/54624_hyundai'))?.default;
        case 'Leo Belting':
            return (await import(/* webpackChunkName: "configLeoBelting" */ './kunden/46950'))?.default;
        case 'Liliensiek':
            return (await import(/* webpackChunkName: "configLiliensiek" */ './kunden/13890'))?.default;
        case 'Marnet':
            return (await import(/* webpackChunkName: "configMarnet" */ './kunden/54619'))?.default;
        case 'Nullaufhundert':
            return (await import(/* webpackChunkName: "configNullaufhundert" */ './kunden/30150_Nullaufhundert'))?.default;
        case 'Otto Grimm':
            return (await import(/* webpackChunkName: "configOttoGrimm" */ './kunden/30009'))?.default;
        case 'OutletCars':
            return (await import(/* webpackChunkName: "configOutletCars" */ './kunden/54630'))?.default;
        case 'Reim Automobile':
            return (await import(/* webpackChunkName: "configReim" */ './kunden/54090'))?.default;
        case 'Rolf Moser':
            return (await import(/* webpackChunkName: "configRolfMoser" */ './kunden/54802'))?.default;
        case 'Schäfer Automobile':
            return (await import(/* webpackChunkName: "configSchaeferAutomobile" */ './kunden/54330'))?.default;
        case 'Schmeink-Gruppe-DEV':
            return (await import(/* webpackChunkName: "configSchmeinkDev" */ './kunden/54632-dev'))?.default;
        case 'Schmeink-Gruppe':
            return (await import(/* webpackChunkName: "configSchmeink" */ './kunden/54632'))?.default;
        case 'Spindler':
            return (await import(/* webpackChunkName: "configSpindler" */ './kunden/54390'))?.default;
        case 'Sportivo':
            return (await import(/* webpackChunkName: "configSportivo" */ './kunden/30124'))?.default;
        case 'Thomas Exclusive Cars':
            return (await import(/* webpackChunkName: "configThomasExclusive" */ './kunden/30181'))?.default;
        case 'Thomas Exclusive Cars - Aston Martin':
            return (await import(/* webpackChunkName: "configThomasExclusiveAstonMartin" */ './kunden/30181_astonMartin'))?.default;
        case 'Thomas Heavy Metal Bikes':
            return (await import(/* webpackChunkName: "configThomasHeavyMetal" */ './kunden/30177'))?.default;
        case 'Vogt Mobil':
            return (await import(/* webpackChunkName: "configVogt" */ './kunden/54783'))?.default;
        case 'VW Arnold':
            return (await import(/* webpackChunkName: "configArnold" */ './kunden/53180'))?.default;
        case 'Walter Schneider GmbH & Co KG':
            return (await import(/* webpackChunkName: "configWalterSchneider" */ './kunden/54613'))?.default;

        // FOR TESTS - DO NOT DELETE!
        case 'Test':
            return (await import(/* webpackChunkName: "configTest" */ './_test'))?.default;
    }
}
